import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from './root-reducer';

const enableMiddleware = (...middlewares) => {
  if (process.env.NODE_ENV !== 'production') {
    return composeWithDevTools(applyMiddleware(...middlewares));
  }

  return compose(applyMiddleware(...middlewares));
};

let store;

const configureStore = initialState => {
	const persistedState = localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME) 
						? JSON.parse(localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME))
						: null
	store = createStore(
		rootReducer,
		persistedState ? persistedState : initialState,
		enableMiddleware(thunkMiddleware)
	);

  return store;
};

export default configureStore;

export const getStore = () => store;
